import script from "./owner-note.vue?vue&type=script&setup=true&lang=js"
export * from "./owner-note.vue?vue&type=script&setup=true&lang=js"

import "./owner-note.vue?vue&type=style&index=0&id=497be908&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497be908"]])

export default __exports__